var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("TodoList", {
    attrs: {
      json: _vm.todoJson,
      cells: _vm.cells,
      editable: !_vm.disabled,
      canDeleteItemFn: e => !e.fromDuty
    },
    on: { change: _vm.todoListChanged }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }